import { Typography } from 'mobily-ui-library/lib';
import { useTranslation } from 'react-i18next';
import SelfServicekiosk from '../../../assets/SelfServiceKiosk.svg';
import WheelChair from '../../../assets/WheelChair.svg';

import './StoreList.scss';

type Props = {
    storeName: any,
    status: string,
    timings: string,
    storeDistance: any;
    rtl: boolean;
    storeId: string;
    handleListClick: any;
    store: any;
    ssk: any;
    disabilityFriendly: any;
}

function StoreList({ store, storeName, status, timings, disabilityFriendly, ssk, storeDistance, rtl, storeId, handleListClick }: Props) {
    const { t } = useTranslation();
    const color = (status.toLowerCase().replace(/\s/g, '') === 'open' || status.toLowerCase().replace(/\s/g, '') === 'مفتوح' ) ? '#00bf99' : '#B9BFC6';
    const handleListItem = (el: any) => {
        handleListClick(el.priority)
    }

    return (
        <div className='storeList_container' id={storeId} style={{ [rtl ? "paddingRight" : "paddingLeft"]: "0px" }} onClick={() => handleListItem(store)}>
            <Typography rtl={rtl} className='storeName'>{storeName}</Typography>
            <div className={rtl ? 'store_card_arabic store_card' : 'store_card'}>
                <div className='store_status'>
                    <Typography rtl={rtl} className='timings'>{timings}</Typography>
                    <Typography rtl={rtl} className='status' color={color}>{status}</Typography>
                </div>
                <Typography rtl={rtl} className='store_distance'>
                    {storeDistance}
                </Typography>
            </div>
            <div className={rtl ? 'store_card_service_arabic store_card_service' : 'store_card_service'}>
                {ssk === 'True' &&
                 <Typography rtl={rtl} className='status' ><img src={SelfServicekiosk} alt='SelfServicekiosk' />{t('self_service_kiosk')}</Typography>}
                {disabilityFriendly === 'True' && 
                <Typography rtl={rtl} className='status'><img src={WheelChair} alt='WheelChair'/>{t('disability_friendly')}</Typography>}
            </div>
        </div>
    )
}

export default StoreList